/**
 * Sliders module
 */

var Sliders = (function($) {
  function initActualidadSlider() {
    const slider = document.querySelector(".actualidad-slider");

    if (!slider) return;

    new Swiper(slider, {
      slidesPerView: 1.15,
      spaceBetween: 0,
      speed: 800,
      grabCursor: true,
      loop: false,

      freeMode: {
        enabled: true,
        momentum: true,
      },

      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },

      //   scrollbar: {
      //     el: ".actualidad-slider .swiper-scrollbar",
      //     draggable: true,
      //     hide: false,
      //     snapOnRelease: false,
      //   },

      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 2.5,
        },
      },
    });
  }

  function init() {
    if (!$(".swiper").length) {
      return;
    }

    initActualidadSlider();
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(document).ready(Sliders.init);
